/**
 * 描述：素材库三级菜单
 * 日期：2017-8-22
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('resourceCenterMediaResourceLeftModule', [])
    .directive('mediaResourceLeft', ['$q', '$timeout', 'resourceCenterService', '$state', '$stateParams', 'trsHttpService', function($q, $timeout, resourceCenterService, $state, $stateParams, trsHttpService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: './resourceCenter/materialResource/left/left_tpl.html',
            scope: {
                selectedParent: '=',
            },
            link: function($scope, $elem, $attr) {
                initStatus();
                // eslint-disable-next-line lines-around-comment
                /**
                 * [selectLeve3 description] 选中新华社稿三级菜单
                 * @param  {[type]} item [description] 三级菜单信息
                 * @return {[type]}      [description]
                 */
                $scope.selectLeve3 = function(item) {
                    $scope.status.selected = item.name;
                    let params = {
                        resourcetype: item.resourceType,
                    };
                    resourceCenterService.go('front.resourcectrl.mediaresource.resource', params);
                };
                

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {};
                    $scope.status.selected = getInitSelected();
                }

                /**
                 * [getInitSelected 初始化选中的菜单项]
                 *
                 * @return  {[type]}  [return description]
                 */
                function getInitSelected(){
                    let selectedMap = {
                        '0': '图片',
                        '1': '音频',
                        '2': '视频',
                    };
                    let resourceType = $stateParams.resourcetype;
                    return selectedMap[resourceType];
                }
            }
        };
    }]);